import { Injectable } from '@angular/core';
import { CommandHandlerRegistryService } from './command/command-registry.service';
import { AuthCommandHandlerService } from './auth/auth-command-handler.service';
import { OrderCommandHandlerService } from './order/order-command-handler.service';
import { ShipmentCommandHandlerService } from "./shipment/shipment-command-handler.service";
import { KaskoCommandHandlerService } from './kasko/kasko-command-handler.service';
import { FinancingCommandHandlerService } from './financing/financing-command-handler.service';
import { DropshippingCommandHandlerService } from './dropshipping/dropshipping-command-handler.service';
import { RicondizionatoCommandHandlerService } from './ricondizionato/ricondizionato-command-handler.service';
@Injectable()
export class CommandHandlerConfiguratorService {
  constructor(
    private auth: AuthCommandHandlerService,
    private order: OrderCommandHandlerService,
    private shipment: ShipmentCommandHandlerService,
    private kasko: KaskoCommandHandlerService,
    private financing: FinancingCommandHandlerService,
    private dropshipping: DropshippingCommandHandlerService,
    private ricondizionato: RicondizionatoCommandHandlerService
  ) {}

  configure(registry: CommandHandlerRegistryService) {
    registry
      .register("login", this.auth)
      .register("logout", this.auth)
      .register("notify_user_unverified", this.auth)
      .register("mark_auth_as_initialized", this.auth)

      .register("add_current_wizzard_step", this.order)
      .register("add_customer_phone", this.order)
      .register("add_brand_to_customer_phone", this.order)
      .register("add_model_to_customer_phone", this.order)
      .register("add_details_to_customer_phone", this.order)
      .register("add_estimation_id", this.order)
      .register("add_customer_id", this.order)
      .register("add_order_id", this.order)
      .register("add_shipment_to_customer", this.order)
      .register("add_customer_type", this.order)
      .register("add_client_phone", this.order)
      .register("add_brand_to_client_phone", this.order)
      .register("add_model_to_client_phone", this.order)
      .register("add_issues_to_client_phone", this.order)
      .register("add_customer_details", this.order)
      .register("add_estimate", this.order)
      .register("add_payment_id", this.order)
      .register("add_payment", this.order)
      .register("add_invoice_pdf_id", this.order)
      // .register('change_order_status', this.orderList)

      .register("add_current_shipment_wizzard_step", this.shipment)
      .register("add_receiver_type", this.shipment)
      .register("add_receiver", this.shipment)
      .register("add_sender", this.shipment)
      .register("add_selected_order", this.shipment)
      .register("add_shipment_id", this.shipment)

      .register("add_current_wizzard_step_kasko", this.kasko)
      .register("add_kasko_id", this.kasko)
      .register("add_init_info_kasko", this.kasko)
      .register("add_phone_info_kasko", this.kasko)
      .register("add_customer_type_kasko", this.kasko)
      .register("add_customer_id_kasko", this.kasko)
      .register("add_payment_id_kasko", this.kasko)

      .register("add_current_wizzard_step_financing", this.financing)
      .register("add_sale_id", this.financing)
      .register("add_init_info_financing", this.financing)
      .register("add_phone_info_financing", this.financing)
      .register("add_customer_type_financing", this.financing)
      .register("add_total_sale", this.financing)
      .register("add_customer_id_financing", this.financing)
      .register("add_payment_id_financing", this.financing)

      .register("add_current_wizzard_step_dropshipping", this.dropshipping)
      .register("add_sale_id_dropshipping", this.dropshipping)
      .register("add_init_info_dropshipping", this.dropshipping)
      .register("add_phone_info_dropshipping", this.dropshipping)
      .register("add_customer_type_dropshipping", this.dropshipping)
      .register("add_total_sale_dropshipping", this.dropshipping)
      .register("add_customer_id_dropshipping", this.dropshipping)
      .register("add_payment_id_dropshipping", this.dropshipping)

      .register("add_current_wizzard_step_ricondizionato", this.ricondizionato)
      .register("add_sale_id_ricondizionato", this.ricondizionato)
      .register("add_init_info_ricondizionato", this.ricondizionato)
      .register("add_phone_info_ricondizionato", this.ricondizionato)
      .register("add_customer_type_ricondizionato", this.ricondizionato)
      .register("add_total_sale_ricondizionato", this.ricondizionato)
      .register("add_customer_id_ricondizionato", this.ricondizionato)
      .register("add_payment_id_ricondizionato", this.ricondizionato);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/command-handler-configurator.service.ts